import { combineReducers } from 'redux'

import changeForgottenPasswordSlice from './ChangeForgottenPassword/reducer'
import forgottenPasswordSlice from './ForgottenPassword/reducer'
import hallSlice from './Hall/reducer'
import loginSlice from './Login/reducer'
import orderSummarySlice from './OrderSummary/reducer'
import paymentFailSlice from './PaymentFailed/reducer'
import PaymentVerify from './PaymentVerify/reducer'
import registerSlice from './Register/reducer'
import cinestarClubSlice from './UserProfile/components/CinestarClub/reducer'
import accountOrdersSlice from './UserProfile/components/TicketsAndReserv/reducer'
import userProfileSlice from './UserProfile/reducer'
import yourOrderSlice from './YourOrder/reducer'

export default combineReducers({
    changeForgottenPassword: changeForgottenPasswordSlice,
    forgottenPassword: forgottenPasswordSlice,
    hall: hallSlice,
    login: loginSlice,
    register: registerSlice,
    userProfile: userProfileSlice,
    cinestarClub: cinestarClubSlice,
    yourOrder: yourOrderSlice,
    orderSummary: orderSummarySlice,
    accountOrders: accountOrdersSlice,
    paymentVerify: PaymentVerify,
    paymentFail: paymentFailSlice,
})
